import { render, staticRenderFns } from "./expense.vue?vue&type=template&id=9209b0a2"
import script from "./expense.vue?vue&type=script&lang=js"
export * from "./expense.vue?vue&type=script&lang=js"
import style0 from "./expense.vue?vue&type=style&index=0&id=9209b0a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports